export default __webpack_public_path__ + "static/media/left4.2dbd84af.png";